import type { Cursor, CursorEditor, YjsEditor as SlateYjsEditor } from '@tunasong/sync-lib'
import { getRemoteCaretsOnLeaf } from '@tunasong/sync-lib/react'

/** The slate-yjs editor plus its cursors. Its own name used to shadow the import it extends (lint, typescript-eslint 8.72) */
export interface YjsEditor extends SlateYjsEditor, CursorEditor {
  cursors: Cursor[]
}

export interface YjsState {
  userId: string
  color: string // rgb
  alphaColor: string
  anchor: YjsCaretPoint
  focus: YjsCaretPoint
}

export interface YjsCaretPoint {
  type: {
    client: string
    clock: number
  }
}
export interface YjsCaret {
  data: YjsState
  isForward: boolean
  isCaret: boolean
}

export function isCaret(range?: unknown): range is YjsCaret {
  const carets = getRemoteCaretsOnLeaf(range)

  return carets.length > 0
}
